import { EnvironmentEnum } from '@sites/util-environment';

export const environment = {
  name: EnvironmentEnum.Dev,
  production: false,
  // Replaced by actual value during build
  release: '__RELEASE_NAME__',

  dashboardUrl: 'https://dashboard-dev.humanmademachine.com',

  apiUrl: 'https://api-dev.humanmademachine.com',

  sentryDsn:
    'https://6504ab8504ec4403bbb00bfca4943b4c@o98546.ingest.sentry.io/6111916',
  sentrySampleRate: 1.0,
};
